import {Component, EventEmitter, inject, Input, Output, ViewChild} from '@angular/core';
import {FormPopupComponent} from "../../../../components";
import {SupplierFormComponent} from "../supplier-form/supplier-form.component";
import {CreateSupplierCommand, SuppliersClient} from "@services";
import notify from "devextreme/ui/notify";

@Component({
    selector: 'add-supplier-form',
    imports: [
        FormPopupComponent,
        SupplierFormComponent
    ],
    templateUrl: './add-supplier-form.component.html'
})
export class AddSupplierFormComponent {
    @ViewChild(SupplierFormComponent, {static: false}) addNewForm: SupplierFormComponent;

    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() onSave = new EventEmitter();

    private suppliersClient = inject(SuppliersClient);

    onPopupSaveClick = () => {
        let formData = this.addNewForm.getData();

        let createCommand = new CreateSupplierCommand({
            number: formData.number,
            status: formData.status,
            name: formData.name,
            group: formData.group,
            plant: formData.plant,
            sac: formData.sac,
            address: formData.address,
            phone: formData.phone,
            email: formData.email,
        })
        this.suppliersClient.createSupplier(createCommand).subscribe({
            next: async () => {
                this.visible = false;
                this.visibleChange.emit(this.visible);
                this.onSave.emit();
            },
            error: (errors: Array<any>) => {
                errors.forEach((errMsg => {
                    notify({
                        message: errMsg.message,
                        type: "error",
                        displayTime: 5000,
                    }, {
                        position: "bottom right",
                        direction: "up-push"
                    });
                }));
            }
        });
    };

    onVisibleChange(visible: boolean) {
        this.visibleChange.emit(visible);
    }
}